module.exports = __webpack_public_path__ + "img/nocart.f95457c1.png";